import { postWithAuth, putWithAuth } from '../InitializeService';
import { AxiosInstance } from 'axios';
export interface IListItemReq {
  siteUrl: string;
  listName: string;
  itemId?: number;
  fieldValues: Record<string, any>;
  user: string;
}
export interface IUpdateUPReq {
  properties: Record<string, any>;
  siteUrl: string;
}
export const addListItem = (instance: AxiosInstance, req: IListItemReq) => {
  return postWithAuth('sharepoint/lists/items', req, instance);
}
export const updateListItem = (instance: AxiosInstance, req: IListItemReq) => {
  return putWithAuth('sharepoint/lists/items', req, instance);
}

export const updateUserProfile = (instance: AxiosInstance, req: IUpdateUPReq, userId: string) => {
  return postWithAuth(`sharepoint/userprofiles?userId=${userId}`, req, instance);
}